import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserService } from '../services/user.service';

/** Destino home según sesión (misma regla que `HeaderComponent.goBack`). */
export function resolveSessionHomeUrlTree(router: Router, userService: UserService): UrlTree {
  const user = userService.getUser();
  if (user?.actor === 'microempresario') {
    return router.createUrlTree(['/microempresario/home']);
  }
  if (user?.actor === 'intermediario') {
    return router.createUrlTree(['/intermediario/home']);
  }
  return router.createUrlTree(['/home']);
}

/** Rutas desconocidas (`**`): redirige al home público o al home del perfil logueado. */
export const sessionHomeRedirectGuard: CanActivateFn = () => {
  return resolveSessionHomeUrlTree(inject(Router), inject(UserService));
};
